export const Veraval = {
    title: "Veraval",
    title1: "(Coastal and Historical)",

    attractions: [
        {
            name: "Somnath Temple",
            description: "Somnath Temple is one of the twelve Jyotirlingas of Lord Shiva and holds immense spiritual significance. The temple is renowned for its stunning architecture and is a symbol of India's rich cultural heritage. Located near the Arabian Sea, the temple offers a tranquil experience for pilgrims and tourists.",
            location: "Somnath Temple, Somnath, Gujarat",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the Aarti and prayers",
                "Explore the temple and its surroundings",
                "Photography of the temple and the beach"
            ],
            mapLink: "https://maps.app.goo.gl/2dE7y8F14VvHTJtP8",
        },
        {
            name: "Veraval Beach",
            description: "Veraval Beach is a beautiful, serene beach located near the town of Veraval. It is known for its peaceful atmosphere and is less crowded compared to other beaches. The beach is an ideal spot for relaxation, swimming, and sunset photography.",
            location: "Veraval Beach, Veraval, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Relax by the beach",
                "Photography of the sunset",
                "Swim in the calm waters"
            ],
            mapLink: "https://maps.app.goo.gl/efbzZ6wz1kFHDHq9A",
        },
        {
            name: "Prabhas Patan",
            description: "Prabhas Patan is an ancient historical site located near Somnath. It is believed to be the place where Lord Krishna's mortal remains were taken after his departure. The site is home to ancient ruins and an archaeological museum.",
            location: "Prabhas Patan, Near Somnath, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the ancient ruins",
                "Learn about the history of the site",
                "Photography of the archaeological remains"
            ],
            mapLink: "https://maps.app.goo.gl/5iFwupqDLkjsbtfZ9",
        },
        {
            name: "Bhalka Tirth",
            description: "Bhalka Tirth is an important pilgrimage site in Veraval, associated with the end of Lord Krishna's life. It is believed that Lord Krishna was accidentally shot by a hunter in this location. The temple dedicated to Lord Krishna stands at the site and is visited by devotees seeking spiritual solace.",
            location: "Bhalka Tirth, Veraval, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the prayers and rituals",
                "Explore the temple and its surroundings",
                "Learn about the significance of the site"
            ],
            mapLink: "https://maps.app.goo.gl/3fVtqJxUbMiFRm6D7",
        },
        {
            name: "Veraval Lighthouse",
            description: "The Veraval Lighthouse is located on the Veraval coast and offers panoramic views of the Arabian Sea. The lighthouse is an iconic structure and is an excellent spot for photography and sightseeing.",
            location: "Veraval Lighthouse, Veraval, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Climb the lighthouse for panoramic views",
                "Photography of the sea and coastline",
                "Enjoy the cool breeze and peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/wFsqfQXTjvNRMbhe9",
        },
        {
            name: "Veraval Fort",
            description: "Veraval Fort is an old, historic fort located in the town of Veraval. The fort played a significant role in the region's defense during ancient times. Today, it stands as a historical monument that offers a glimpse into the region's rich past.",
            location: "Veraval Fort, Veraval, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the fort and its walls",
                "Learn about the fort's historical significance",
                "Photography of the fort's architecture"
            ],
            mapLink: "https://maps.app.goo.gl/7nrxF9BAmwbD5w4t9",
        },
        {
            name: "Gita Mandir",
            description: "Gita Mandir is a temple dedicated to Lord Krishna and is located in a peaceful setting near the town of Veraval. The temple is dedicated to the Bhagavad Gita and serves as a place for meditation and reflection.",
            location: "Gita Mandir, Veraval, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and rituals",
                "Read the Bhagavad Gita",
                "Meditate in the temple's peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/9vmKX8oCu6xPqc9r5",
        },
        {
            name: "Sasan Gir National Park",
            description: "Sasan Gir National Park, located near Veraval, is the last remaining home of the Asiatic lion. The park is a wildlife sanctuary that attracts nature lovers and wildlife enthusiasts. It is an ideal place for safaris and birdwatching.",
            location: "Sasan Gir National Park, Near Veraval, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "October to March",
            activities: [
                "Go on a safari to spot Asiatic lions",
                "Bird watching",
                "Photography of wildlife and nature"
            ],
            mapLink: "https://maps.app.goo.gl/P3ygU9uzthSTZYhx5",
        },
        {
            name: "Khodiyar Mandir",
            description: "Khodiyar Mandir is a famous temple located near Veraval, dedicated to the goddess Khodiyar. The temple is a significant pilgrimage site for devotees and is surrounded by natural beauty, making it a peaceful spot for reflection.",
            location: "Khodiyar Mandir, Near Veraval, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the temple prayers and rituals",
                "Explore the surroundings",
                "Learn about the goddess Khodiyar"
            ],
            mapLink: "https://maps.app.goo.gl/7Vt5gs1z5kV7U6wA9",
        }
    ]
};
